import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import PerfectScrollbar from 'react-perfect-scrollbar'
import Typography from '@mui/material/Typography'
import Box, { BoxProps } from '@mui/material/Box'
import { Button, IconButton, Tooltip } from '@mui/material'
import _ from 'lodash'
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { IncomingCallPopupStore } from '../../stores/LeadStore';
//import IncomingCallControls from './IncomingCallControls';


function PaperComponent(props: PaperProps) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}
const MyEnum = {
    xs: 'xs',
    sm: 'sm',
    md: 'md',
    lg: 'sm',
    xl: 'xl',
    false: false

} as const

type MyEnum = typeof MyEnum[keyof typeof MyEnum]

type Props = {
    open: boolean,
    onConfirm: () => void,
    onCancel: () => void
    title: string,
    showIconButton: boolean,
    maxWidth: MyEnum
}


export default function IncomingCallDialog({ open, onConfirm, onCancel, title, showIconButton, maxWidth }: Props) {
    const incomingCallDialogMode = IncomingCallPopupStore.useState(s => s.incomingCallDialogMode);
    const numberCalling = IncomingCallPopupStore.useState(s => s.numberCalling);

    return (

        <Dialog
            sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
            maxWidth={maxWidth}
            fullWidth={true }
            open={open}
            scroll='body'
            aria-labelledby="draggable-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperComponent={PaperComponent}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                <Box
                    className='customizer-header'
                    sx={{
                        position: 'relative',
                        p: theme => theme.spacing(3.5, 5),
                        borderBottom: theme => `1px solid ${theme.palette.divider}`
                    }}
                >
                    <Typography sx={{ fontWeight: 600 }}>
                        {title} from {numberCalling}
                    </Typography>
                    {showIconButton &&
                        <IconButton
                            data-testid='close-button'
                            onClick={onCancel}
                            sx={{
                                right: 20,
                                top: '50%',
                                position: 'absolute',
                                color: 'text.secondary',
                                transform: 'translateY(-50%)'
                            }}
                        >
                            <CloseIcon fontSize='small' />
                        </IconButton>
                    }
                </Box>
            </DialogTitle>
            <DialogContent>
                <PerfectScrollbar options={{ wheelPropagation: false }} >
                    {/*{incomingCallDialogMode &&*/}
                    {/*    <IncomingCallControls/>*/}
                    {/*}*/}

                </PerfectScrollbar>
            </DialogContent>
        </Dialog>

    );
}
